export const gearboxType: { [key: number]: string } = {
  1: 'manual',
  2: 'automatic',
  3: 'CVT',
  4: 'DCT',
  5: 'Semiautomatic',
};
